import { useIntl } from 'react-intl';
import { linkResolver } from 'prismic/linkResolver';
import { PrismicImage } from 'prismic/types/image';
import { Power_Station } from 'prismic-types';

import { RegularOrCroppableImage } from 'components/picture/RegularOrCroppablePicture';
import { PowerStationHero } from 'components/power-station-hero/PowerStationHero';
import { PowerStationStats } from 'components/power-station-stats/PowerStationStats';
import { PowerStationStatsItem } from 'components/power-station-stats/PowerStationStatsItem';
import { asText } from 'components/rich-text/RichText';
import { Section } from 'components/section/Section';
import { Video } from 'components/video/Video';

type Props = { data: Power_Station };

export const PowerStationContainer = ({ data }: Props) => {
  const videoLink = data.video ? linkResolver(data.video) : null;
  const intl = useIntl();

  return (
    <>
      <PowerStationHero
        title={asText(data.title)}
        image={
          data.image ? (
            <RegularOrCroppableImage image={data.image} width={2000} />
          ) : undefined
        }
        video={
          videoLink ? (
            <Video
              isBackgroundVideo={false}
              addLayout={true}
              src={videoLink}
              poster={(data.image as PrismicImage)?.url ?? undefined}
            />
          ) : undefined
        }
      />
      <Section>
        <PowerStationStats>
          <PowerStationStatsItem
            title={intl.formatMessage({ id: 'installed_capacity' })}
            info={data.installed_capacity ? data.installed_capacity : undefined}
          />
          <PowerStationStatsItem
            title={intl.formatMessage({ id: 'average_flow' })}
            info={data.average_flow ? data.average_flow : undefined}
          />
          <PowerStationStatsItem
            title={intl.formatMessage({ id: 'year_operational' })}
            info={data.year ? data.year : intl.formatMessage({ id: 'in_progress' })}
          />
          <PowerStationStatsItem
            image={
              data.image_location ? (
                <RegularOrCroppableImage image={data.image_location} width={100} />
              ) : undefined
            }
            title={intl.formatMessage({ id: 'location' })}
            info={asText(data.location)}
          />
        </PowerStationStats>
      </Section>
    </>
  );
};
